import LandingMobileMenu from './LandingMobileMenu';
import NoHeaderLayout from './NoHeader.layout';
import { InfoLayout } from './Info.layout';
import LandingLayout from './Landing.layout';
import HomeLayout from './Home.layout';
import AuthLayout from './Auth.layout';

export { HomeLayout, AuthLayout, NoHeaderLayout, LandingLayout, LandingMobileMenu, InfoLayout };
